import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from "react-router-dom";
import "./App.scss";
import "./utils/loco.css"
import React, { useEffect, useRef} from "react";
import Frame from "./components/frame";
// import Spline from '@splinetool/react-spline';
// import Scrollbar from "./components/scrollbar/scrollbar.js";

import {
  About,
  Home,
  Contact,
  FaQ,
  Portfolio,
  ErrorPage,
  Services,
  ProjectPage,
  Privacy,
} from "./pages";
import { useAppContext } from "./contexts/appcontext.js";
import Circle from "./components/circle/circle.js"
import ScrollToTop from "./utils/ScrollToTop";

import "./utils/loco.css";
import Test from "./pages/test.jsx"

// import SmoothScrollbar from 'smooth-scrollbar';
// import ScrollTriggerPlugin from './utils/ScrollTriggerPlugin';
// import SoftScrollPlugin from './utils/SoftScrollPlugin';

function App() {
  const { isMobile, setMobileTrue, setMobileFalse } = useAppContext();


  function checkForMobileBg() {
    const width = window.innerWidth;

    if (width > 768 && isMobile) {
      setMobileFalse();
    } else if (width < 768 && !isMobile) setMobileTrue();
  }
  checkForMobileBg();

  useEffect(() => {
    
    checkForMobileBg();

    window.addEventListener("resize", checkForMobileBg);

    return () => window.removeEventListener("resize", checkForMobileBg);
    
  }, [isMobile,setMobileTrue,setMobileFalse]);
  const circleRefs = useRef([]);
  circleRefs.current = [];
  useEffect(() => {
    const onMove = ({ clientX, clientY }) => {      
      circleRefs.current.forEach(ref => ref.moveTo(clientX, clientY));
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, []);
  
  

  return (
    <Router>
      <Frame />
      <ScrollToTop />
      {
        !isMobile?<Circle size="sm" delay="0"/> : null
        
        }
     
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>

        <Route path="/projects/:id" children={<ProjectPage />} />

        <Route path="/projects/:tag?" exact >
          <Test />
        </Route>

        <Route path="/faq" exact>
          <FaQ />
        </Route>
        <Route path="/about" exact>
          <About />
        </Route>

        <Route path="/contact" exact>
          <Contact />
        </Route>

        <Route path="/services" exact>
          <Services />
        </Route> 
        <Route path="/privacyandpolicy" exact>
          <Privacy />
        </Route>
      
        
        {/* <Route path="/test" exact>
          <Test />
        </Route>  */}
        
        <Route path="*">
          <ErrorPage />
        </Route>
      </Switch>
      <svg class="overlay" width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
			<path class="overlay__path" vector-effect="non-scaling-stroke" d="M 0 0 V 0 Q 50 0 100 0 V 0 z" fill="#dcdcdc"></path>
	  	</svg>
 
    </Router>
  );
}

export default withRouter(App);
